var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cafe_type3", attrs: { id: "daumWrap" } }, [
    _c(
      "header",
      { staticClass: "daum_head daum_head--fixed", attrs: { id: "daumHead" } },
      [
        _c("div", { staticClass: "cafe_head" }, [
          _c("h1", { staticClass: "sr_only" }, [_vm._v(_vm._s(_vm.grpname))]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "cafe_navi cafe_navi_type1 schedule_detail_header",
              attrs: { id: "cafe_navi_default" },
            },
            [
              _c("h2", { staticClass: "tit_day" }, [
                _vm._v(_vm._s(_vm.formattedDate)),
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "link_close",
                  attrs: { href: _vm.monthlyScheduleLink },
                },
                [
                  _c("span", { staticClass: "ico_cafe ico_close" }, [
                    _vm._v("닫기"),
                  ]),
                ]
              ),
            ]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("hr", { staticClass: "hide" }),
    _vm._v(" "),
    _c("main", { staticClass: "cont_schedule", attrs: { id: "daumContent" } }, [
      _c("article", { attrs: { id: "mArticle" } }, [
        _c(
          "div",
          { staticClass: "day_schedule" },
          [
            _c("h3", { staticClass: "sr_only" }, [_vm._v("상세일정")]),
            _vm._v(" "),
            _vm.schedules.length > 0
              ? _vm._l(_vm.schedules, function (schedule) {
                  return _c("schedule-item", {
                    key: schedule.scheduleId,
                    attrs: {
                      schedule: schedule,
                      "calendar-id": _vm.calendarId,
                      "is-admin": _vm.isAdmin,
                    },
                    on: { delete: _vm.onDelete },
                  })
                })
              : _c("p", { staticClass: "schedule_empty" }, [
                  _vm._v("해당 일에 등록된 일정이 없습니다."),
                ]),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }